import { render, staticRenderFns } from "./dragDropEmailCouponBlock.vue?vue&type=template&id=4a9efc47&"
import script from "./dragDropEmailCouponBlock.vue?vue&type=script&lang=js&"
export * from "./dragDropEmailCouponBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports